export enum PretestSwitchCases {
  instruction = 'instruction',
  pretest = 'pretest',
  summary = 'summary',
}
